import { BaseState } from '@/store/base-state';
import { TableOptions } from '@/types';
import { Polls, PollsFilters } from '../types';

export default class PollsState extends BaseState {
  polls: Polls.Poll[] = [];
  current_poll: Polls.CurrentPoll = {
    id: null,
    link_page: {
      id: null,
      name: null,
      slug: null,
    },
    preview_text: null,
    sections: [],
    status: {
      id: null,
      name: null,
      slug: null,
    },
    title: null,
    type: {
      id: 0,
      name: '',
      slug: '',
    },
  };

  show_success_dialog = false;
  is_matched_route_slug = false
  poll_id: number | null = null;

  start_time = '';
  has_sent = false;
  stepper_loading = false;

  questions: Polls.Answers[] = [];

  filters: PollsFilters = {};

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: ['published_at '],
    sortDesc: [true],
  };
}
